import React, { useEffect, useState } from "react";
import { incrementGeneralArray } from "../firebase/fireFuncs";

import { forArrayLength } from "../misc/helperfuncs";
import MainStore from "../stores/MainStore";
import useCreateModal from "./useCreateModal";
import useHandleBoxTypes from "./useHandleBoxTypes";

const useHandleOpenObject = ({ onOpened, objects, onBack }) => {
  const [openPayload, setOpenPayload] = useState(null);
  const { player } = MainStore();
  const { getPluralType, getBoxType } = useHandleBoxTypes();

  useEffect(() => {
    if (objects) {
      const boxType = getBoxType(objects.general.type);
      const newPayload = {};
      if (objects.saved) {
        newPayload.shortDescription = objects.saved.shortDescription;
        newPayload.categories = objects.saved.categories;
        newPayload.keywords = objects.saved.keywords;
        newPayload.things = objects.saved.things;
        newPayload.image = objects.saved.image;
        forArrayLength(boxType.related.types, (relatedTypes) => {
          newPayload[relatedTypes] = objects.saved[relatedTypes];
        });
      } else {
        newPayload.shortDescription = objects.general.shortDescription;
        newPayload.id = objects.general.id;
        newPayload.image = objects.general.image;
        newPayload.categories = objects.general.categories;
        newPayload.keywords = objects.general.keywords;
        forArrayLength(boxType.related.types, (relatedTypes) => {
          newPayload[relatedTypes] = objects.general[relatedTypes];
        });
      }
      setOpenPayload(newPayload);
    }
  }, [objects]);

  function onObjectOpened(openObject) {
    incrementGeneralArray(
      getPluralType,
      openObject,
      "open",
      "player",
      player.uid,
      onOpened
    );
  }

  const createModal = useCreateModal({
    type: objects?.general.type,
    payload: openPayload,
    action: "Open",
    onObjectCreated: onObjectOpened,
  });

  return { modal: <div>{createModal.divs}</div>, open: createModal.open };
};

export default useHandleOpenObject;
